<pbc-filter [config]="MitarbeiterFilterConfig" [filter]="mitarbeiter.filter$ | async" (filterChange)="mitarbeiter.filter$.next($event)"></pbc-filter>
